const CardServicios = ({ data, onClick, disabled }) => {
    return (
      <div
         id={`serv${data.AreaId}${data.ServicioId}`}
         className={`flex w-full h-[4.0rem] lg:h-[4.5rem] items-center bg-white text-dark rounded-lg shadow-lg shadow-default border border-stone-200 
                   ${disabled ? 'opacity-50 pointer-events-none' : 'hover:cursor-pointer hover:bg-body hover:scale-110 transition-transform duration-300'}`} 
                    onClick={()=> !disabled && onClick(data)}
      >
      <div className="flex flex-row w-full h-full text-[1.5rem] text-sidebar">
          <div className="h-full w-[4.5rem] border-r font-medium border-stone-500 bg-sidebar flex items-center justify-center px-4 rounded-l-lg">
            <span className="text-[0.95rem] lg:text-[1.5rem] font-bold text-body leading-none">
               {data.Prefijo}
            </span>
         </div>
         <div className="flex w-full h-full items-center justify-center">
             <span className="w-full text-[0.85rem] lg:text-[1.5rem] text-center truncate">
               {data.NombreServ}
             </span>
          </div>
      </div>
</div>
      
    );
  };
export default CardServicios;